import React from "react";

/**
 * Very small inline formatter:
 * - Supports **bold** only
 * - Everything else is rendered as plain text
 */
export function renderInlineEmphasis(text) {
	if (!text) return null;

	// Split on segments like **...**
	const segments = text.split(/(\*\*[^*]+\*\*)/g);

	return segments.map((segment, index) => {
		if (segment.startsWith("**") && segment.endsWith("**") && segment.length > 4) {
			const inner = segment.slice(2, -2); // remove ** at both ends
			return <strong key={index}>{inner}</strong>;
		}

		return <React.Fragment key={index}>{segment}</React.Fragment>;
	});
}
